/**
 * A configuração única do script do Google Maps (MV2-1706).
 *
 * O script do Maps é um singleton na página: quem carrega primeiro define a URL, e uma
 * segunda chamada com opções diferentes injeta outro script. Com dois scripts existem
 * duas cópias do namespace `google.maps`, e um objeto criado por uma cópia é recusado pela
 * outra dentro do próprio código do Google — o erro chega ao React sem mensagem, por ser
 * de outra origem, e desmonta a árvore inteira: página branca.
 *
 * O dashboard tem três mapas — o da home, o do formulário de endereço da estação e o da
 * aba Estações (Interoperabilidade) —, e cada um tinha a sua configuração. Agora os três
 * usam este objeto, que é uma constante de módulo: a URL passa a ser sempre a mesma, e a
 * biblioteca compara a **referência** do array de `libraries`, então um literal em cada
 * chamada recarregaria o script.
 *
 * Sem `libraries`: nenhum dos três precisa de biblioteca opcional. A `visualization` esteve
 * aqui enquanto o mapa de calor usava o Heatmap Layer, que o Google removeu da Maps
 * JavaScript API na versão 3.65 — a densidade passou a ser desenhada com retângulos do
 * núcleo da API, e carregar biblioteca que ninguém usa é peso sem retorno.
 *
 * O googleMaps.test.ts confere que nenhum carregador novo apareça fora daqui.
 */
export const GOOGLE_MAPS_LOADER_OPTIONS = {
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_API as string,
};
